import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle, Gamepad2 } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-purple-950 text-white flex flex-col items-center justify-center p-8">
      <div className="max-w-md w-full bg-black/60 backdrop-blur-xl border border-white/10 rounded-sm p-8 text-center">
        <div className="mb-6 mx-auto w-16 h-16 flex items-center justify-center bg-red-500/20 rounded-full">
          <AlertTriangle size={32} className="text-red-400" />
        </div>
        
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-cyan-400 to-fuchsia-600 rounded-full blur opacity-75"></div>
            <Gamepad2 className="relative w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-black tracking-widest italic">NEXUS</h1>
        </div>
        
        <h2 className="text-3xl font-bold mb-4">404</h2>
        <p className="text-gray-300 mb-8">
          Oops! Parece que você encontrou um portal para uma dimensão inexistente.
        </p>
        
        <Link
          to="/"
          className="flex items-center justify-center gap-2 py-3 bg-gradient-to-r from-cyan-500 to-fuchsia-600 hover:shadow-[0_0_20px_rgba(34,211,238,0.5)] rounded-sm font-bold transition-all group"
        >
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
          <span>Voltar para o início</span>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;